import React from 'react';
import Button from '@mui/material/Button';
import cx from 'classnames';
import styles from '@/common/containers/Modals/UserGuide/styles.less';
import image from '@/common/assets/guide/edit.png';
import imageFr from '@/common/assets/guideFr/edit.png';
import { Trans, useTranslation } from 'react-i18next';
import CopyrightSup from '@/common/components/CopyrightSup';
import useLocale from '@/common/hooks/useLocale';

const EditOverview = ({ onClose }) => {
  const { t } = useTranslation();
  const { isFr } = useLocale();
  const copyrightSup = <CopyrightSup />;
  return (
    <>
      <div className={styles.modalHeader}>
        <h3>
          <Trans
            i18nKey="PAEM After Care<copyrightSup/> overview"
            components={{ copyrightSup }}
          />
        </h3>
      </div>
      <div className={cx(styles.modalBody, styles.overview)}>
        <p className={styles.overviewText}>
          <Trans
            i18nKey="You can access the questionnaire at any time by clicking the <2>Edit Questionnaire</2> button."
            components={{ 1: <b />, 2: <b /> }}
          />
        </p>
        <img
          className={styles.overviewImg}
          src={isFr ? imageFr : image}
          alt={t('edit overview')}
        />
      </div>
      <div className={styles.modalFooter}>
        <div className={styles.modalFooterBtns}>
          <Button variant="contained" type="success" onClick={onClose}>
            {t('Ok')}
          </Button>
        </div>
      </div>
    </>
  );
};

export default EditOverview;
